import { Button, Stack, Typography } from "@mui/material";
import * as labels from "config.labels";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const TooManyClaimsOverlay = ({ override, onApplyOverride }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const formattedOverride = override.toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });

  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      sx={{
        width: "100%",
        height: "100%",
        background: "rgba(200, 200, 200, 0.75)",
      }}
    >
      <Stack
        direction={"column"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        zIndex={100}
      >
        <Typography variant={"h6"} gutterBottom>
          {translateLabel(labels.CLAIMS_CHART_TOO_MANY_CLAIMS, {
            default: "Too many claims to plot, try setting a higher attachment",
          })}
        </Typography>
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => onApplyOverride(override)}
          sx={{ mt: 2 }}
        >
          {translateLabel(labels.CLAIMS_CHART_SET_TO_BUTTON, {
            default: "Set to {formattedOverride}",
            replacements: { formattedOverride },
          })}
        </Button>
      </Stack>
    </Stack>
  );
};

export default TooManyClaimsOverlay;
